<template>
  <div class="container error-container">
    <h1 v-if="error.statusCode === 404">お探しのページが見つかりません</h1>
    <h1 v-else>サーバーでエラーが発生しました</h1>
    <p v-if="error.statusCode === 404">
      お客様がアクセスされたページは、削除されたかURLが変更されている可能性がございます。
    </p>
    <p v-else>
      一時的なエラーの可能性もありますので、しばらく経ってから再度アクセスを試してみて下さい。
    </p>
    <p>
      <a href="/">トップページに戻る</a>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    error: {
      type: Object,
      default: () => {
        return { statusCode: '' }
      }
    }
  }
}
</script>
